import type { RouterConfig } from "@nuxt/schema";

export default <RouterConfig>{
  // TODO: Remove this once we have a better solution for
  // broken scroll to top behavior on the Reefgen campaign page
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return {
      top: 0,
      left: 0,
    };
  },
};
